import styled from 'styled-components';

export const LogoutSection = styled.div`
  background: #fff;
  box-shadow: 1px 1px 2px 0px #00000033;
  position: absolute;
  top: 44px;
  z-index: 10;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0px 23px;
  left: 30%;
  cursor: pointer;
  font-size: 14px;
`;
